// JavaScript Document
/* Slider List */
function sliderli(callback, append, directory = "", loop) {
    var sliderlist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + directory + callback + '.jsonp',
        type: "GET",
        dataType: "jsonp",
        jsonpCallback: callback,
        error: function() {
            // エラーハンドリング
        },
        success: function(json) {
            var len = json.length;
            var Now = new Date();
            for (var i = 0; i < len; i++) {
                if (json[i].url_o != "") { 
                    if (!json[i].term_start || (new Date(json[i].term_start) <= Now && Now <= new Date(json[i].term_end))) {
                        sliderlist = '<li><a href="' + json[i].url_o + '" target="_top">' + '<img src="' + json[i].img + '" alt="' + json[i].name + '"></a></li>';
                    } else {
                        sliderlist = '';
                    }
                    $(append).append(sliderlist);
                }
            }

$(document).ready(function(){
  $('.slick01').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    draggable: true,
    infinite: true,
//    variableWidth: true,
    centerMode: true,
    centerPadding: "27%",
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: "15%",
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: "5%",
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: "2%",
          slidesToShow: 1,
        }
      }
    ]
  });
});

		}
    })
};